<template>
  <div data-component-group="lists" data-component="activity-logs">
    <slot name="beforeForm" />

    <v-list lines="two" class="logs-list">
      <v-list-item
        v-for="log in rows"
        :key="log.actor + log.msg"
        class="log-item"
      >
        <!--<v-list-item-avatar>-->
        <v-avatar>
          <v-icon>account_circle</v-icon>
        </v-avatar>

        <div>
          <v-list-item-title :title="`${log.actor} ${log.msg}`">
            <span class="actor">
              {{ log.actor }}
            </span>
            {{ ' ' }}
            <span class="action">
              {{ log.msg }}
            </span>
          </v-list-item-title>

          <span
            v-if="hasAdditionalText(log)"
            class="subtitle"
            v-html="log.additionalText"
          />

          <span class="timestamp">
            {{ log.timestamp }}
          </span>
        </div>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
  import { isNull, isNum, isStr } from '@/utils';

  export default {
    props: {
      rows: {
        type: Array,
        required: true,
        validator(prop) {
          return prop.every(
            ({ actor, msg, additionalText, timestamp }) =>
              isStr(actor) &&
              isStr(msg) &&
              (isNull(additionalText) || isStr(additionalText)) &&
              (isStr(timestamp) || isNum(timestamp)),
          );
        },
      },
    },
    emits: ['change-page'],
    methods: {
      hasAdditionalText({ additionalText }) {
        return isStr(additionalText) && additionalText !== '';
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../assets/styles/theme' as *;

[data-component-group='lists'][data-component='activity-logs'] {
  padding: $spacing-xl;
  background-color: rgb(var(--v-theme-surface));
  border-top: 1px solid map.get($colors, grey, lighten-2);

  .logs-list {
    overflow-x: hidden;
    border-radius: $border-radius;
    padding: 0;
    margin: 0;
  }

  .log-item {
    padding: 0;

    &:last-child {
      border: none;
    }
  }

  .action {
    color: map.get($colors, grey, base);
  }

  .subtitle {
    display: block;
    color: map.get($colors, grey, darken-2);
    margin: $spacing-sm 0 0 0;

    p {
      font-size: $text-size-sm;
    }
  }

  .timestamp {
    display: block;
    color: map.get($colors, grey, base);
    font-size: $text-size-sm;
  }

  .v-list-item {
    height: auto;
    min-height: 2rem;
    margin: 0 0 $spacing-md 0;
  }

  .v-list-item__avatar {
    min-width: 40px;
    margin: 0 $spacing-xs 0 0 !important;

    .v-icon {
      color: map.get($colors, grey, darken-4);

      .v-theme--dark & {
        color: rgb(var(--v-theme-on-surface));
      }
    }
  }

  > .component-actions {
    padding: $spacing-sm;
    text-align: center;

    .trigger.load-more-rows {
      &:before {
        background-color: map.get($colors, grey, darken-1);
      }
    }
  }
}
</style>
